export default __webpack_public_path__ + "static/media/68.4a82dedd.mp3";